const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the comment count component
 * @argument {Application} Application injected to gain access to the global Application service
 */
app.directive('skillsManager', ['Application', 'Authorization', 'Skills', 'Users', '$translate', function (Application, Authorization, Skills, Users, $translate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/skills-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.translations = {};

      self.settings = {
        tab: 'skills',
        switchTab: function(tab) {
          if (!self.blocklist.initialized && tab === 'blocklist') {
            self.blocklist.init();
          }
          this.tab = tab;
        },
        select: function (skill, type) {
          if (type === 'active') {
            if (this.activeSelections[skill._id]) {
              delete this.activeSelections[skill._id];
              this.checkSelections(this.activeSelections, 'active');
              return;
            }
            this.activeSelections[skill._id] = skill;
            this.activeSelected = true;
            return;
          }
          if (type === 'blocked') {
            if (this.blockedSelections[skill._id]) {
              delete this.blockedSelections[skill._id];
              this.checkSelections(this.blockedSelections, 'blocklist');
              return;
            }
            this.blockedSelections[skill._id] = skill;
            this.blockedSelected = true;
            return;
          }
        },
        checkSelections: function(items, type) {
          if (!Object.keys(items).length) {
            if (type === 'active') {
              self.settings.activeSelected = false;
            } else {
              self.settings.blockedSelected = false;
            }
            return;
          }
        },
        blockedSelections: {},
        activeSelections: {},
        activeSelected: false,
        blockedSelected: false,
        mainClear: false,
        blockedClear: false,
        mainConditions: {
          blocked: '$ne,true'
        },
        blockedConditions: {
          blocked: 'true'
        },
        mainSearch: function(query) {
          self.mainPage.search(query);
        },
        blockSearch: function(query) {
          self.blocklist.search(query);
        }
      };

      self.adding = {
        items: [],
        display: false,
        loading: false,
        term: '',
        keyPress: function(event) {
          if (event.which !== 13 || !this.display) {
            return;
          }
          this.enterSkill();
        },
        enterSkill: function() {
          var item = this.term;
          var index = this.items.length;
          if (this.items.indexOf(item) !== -1) {
            Application.messaging.addMessage({type: 'information', text: self.translation['skillsManager.skill_already_in_list'], duration: 6});
            return;
          }
          this.items.push(item);
          this.term = '';
          var main = this;
          Skills.find({name: '$regex,2,' + item + ',i'}).$promise
          .then(function(items) {
            if (items.length) {
              var remove = main.items.splice(index, 1);
              $translate('skillsManager.skill_already_exists',{remove: remove}).then(function (translation) {
                Application.messaging.addMessage({type: 'information', text: translation, duration: 6});
              });
            }
          });
        },
        remove: function(index) {
          this.items.splice(index, 1);
        },
        addSkills: function() {
          var main = this;
          this.loading = true;
          Skills.createMultiple({}, {skills: this.items, user: self.user._id}).$promise
          .then(function(skills) {
            // no more cache
            self.mainPage.invalidateCache();
            // retrieve the current page
            self.mainPage.get();
            $translate('skillsManager.success_added', { length: skills.length}).then(function (translation) {
              Application.messaging.addMessage({type: 'success', text: translation, duration: 6});
            });
            main.display = false;
            main.loading = false;
          }).catch(function(error) {
            main.loading = false;
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_adding'], duration: 6});
          })
        }
      };

      self.naming = {
        saving: false,
        editing: null,
        inEdit: function(skill) {
          if (skill._id && this.editing && this.editing._id === skill._id) {
            return true;
          }
          return false;
        },
        cancelEdit: function(skill) {
          skill.name = this.editing.name;
          this.editing = null;
        },
        startEdit: function(skill) {
          if (this.editing) {
            Application.messaging.addMessage({type: 'information', text: self.translation['skillsManager.save_or_cancel_first'], duration: 5});
            return;
          }
          if (skill._id) {
            this.editing = JSON.parse(JSON.stringify(skill));
          }
        },
        saveName: function(skill) {
          this.saving = true;
          Skills.update({subresource: skill._id}, {name: skill.name}).$promise
          .then(function(newSkill) {
            skill.name = newSkill.name;
            $translate('skillsManager.skill_updated_with_name',{ name: newSkill.name }).then(function (translation) {
              Application.messaging.addMessage({type: 'success', text: translation, duration: 5});
            });
            self.naming.editing = null;
            self.naming.saving = false;
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_updating_name'], duration: 5});
            self.naming.editing = null;
            self.naming.saving = false;
          });
        }
      };

      self.users = {
        current: null,
        list: [],
        display: false,
        loading: false,
        page: 1,
        per_page: 10,
        query: {},
        optionRestrictions: {
          skills: true
        },
        restrictions: {
          skills: this.current
        },
        refresh: function() {
          this.list = [];
          this.page = 1;
          this.restrictions.skills = this.current;
          this.query = {
            page: this.page,
            per_page: this.per_page,
            skills: this.current,
            fields: 'first_name,last_name,full_name,email,image,role,linked_departments,linked_locations,skills,job_title,hired,createdAt,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name'
          };
        },
        goTo: function(skill) {
          if (!skill || !skill.userCount || !skill._id) {
            return;
          }
          this.current = skill._id;
          this.refresh();
          this.get();
        },
        cancel: function() {
          this.current = null;
          this.page = 1;
          this.list = [];
        },
        get: function() {
          var main = this;
          this.loading = true;
          Users.find(this.query).$promise
          .then(function(users) {
            main.list = users;
            main.loading = false;
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_accessing_user'], duration: 5});
            main.loading = false;
            main.cancel();
          });
        },
        next: function() {
          this.query.page++;
          this.get();
        },
        previous: function() {
          this.query.page--;
          this.get();
        },
        onSearch: function(opts) {
          this.refresh();
          if (!opts) {
            this.get();
            return;
          }

          for (var key in opts) {
            this.query[key] = opts[key];
          }

          this.get();
        }
      };
      self.users.refresh();

      self.removing = {
        loading: false,
        showConfirmation: false,
        cancelConfirmation: function() {
          this.showConfirmation = false;
        },
        removeSelected: function() {
          var items;
          var main = this;
          this.loading = true;
          if (self.settings.tab === 'skills') {
            items = Object.keys(self.settings.activeSelections);
          } else {
            items = Object.keys(self.settings.blockedSelections);
          }
          Skills.removeMultiple({}, {skills: items}).$promise
          .then(function(results) {
            if (self.settings.tab === 'skills') {
              self.mainPage.invalidateCache();
              self.mainPage.get();
              self.settings.activeSelections = {};
              self.settings.activeSelected = false;
              if (self.mainPage.searching) {
                self.settings.mainClear = true;
              }
            } else {
              self.blocklist.invalidateCache();
              self.blocklist.get();
              self.settings.blockedSelections = {};
              self.settings.blockedSelected = false;
              if (self.blocklist.searching) {
                self.settings.blockedClear = true;
              }
            }
            main.loading = false;
            main.cancelConfirmation();
            $translate('skillsManager.success_delete',{ length: results.deleted.length}).then(function (translation) {
              Application.messaging.addMessage({type: 'success', text: translation, duration: 6});
            });
          }).catch(function(error) {
            main.loading = false;
            main.cancelConfirmation();
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_deleting_skills'], duration: 6});
          })
        }
      };

      self.blocking = {
        initialized: false,
        showConfirmation: false,
        checked: false,
        existingItems: [],
        newItems: [],
        matches: [],
        loading: false,
        display: false,
        term: '',
        goTo: function() {
          self.settings.tab = 'blocklist';
          if (this.initialized) {
            return;
          }
          self.blocklist.get();
        },
        cancelConfirmation: function() {
          this.showConfirmation = false;
          if (!this.checked) {
            this.display = true;
          }
          this.checked = false;
        },
        cancelBlocking: function() {
          this.newItems = [];
          this.existingItems = [];
          this.display = false;
        },
        keyPress: function(event) {
          if (event.which !== 13 || !this.display) {
            return;
          }
          this.enterSkill();
        },
        enterSkill: function(skill) {
          if (this.existingItems.length) {
            var item = skill ? skill.name : this.term;
            for (var i = 0; i < this.existingItems.length; i++) {
              if (this.existingItems[i].name && this.existingItems[i].name === item) {
                this.term = '';
                return;
              }
            }
          }
          if (!skill && this.newItems.indexOf(this.term) !== -1) {
            this.term = '';
            return;
          }
          if (skill) {
            this.existingItems.push(skill);
            this.term = '';
            return;
          }
          var main = this;
          var index = this.newItems.length;
          var oldTerm = this.term;

          this.newItems.push(this.term);
          this.term = '';

          Skills.find({name: '$regex,2,' + oldTerm + ',i', blocked: true}).$promise
          .then(function(items) {
            if (items.length) {
              var remove = main.newItems.splice(index, 1);
              $translate('skillsManager.skill_exists_is_blocked',{ remove: remove }).then(function (translation) {
                Application.messaging.addMessage({type: 'information', text: translation, duration: 6});
              });
            }
          });
        },
        remove: function(index, type) {
          if (type === 'new') {
            this.newItems.splice(index, 1);
            return;
          }
          this.existingItems.splice(index, 1);
          return;
        },
        blockSkills: function() {
          var main = this;
          var resetMain = this.checked || this.existingItems.length ? true : false;
          this.loading = true;
          var selected;
          if (this.checked) {
            selected = {
              existingSkills: Object.keys(self.settings.activeSelections),
              newSkills: [],
              user: self.user._id
            };
          } else {
            selected = {
              existingSkills: this.existingItems.map(function(item){return item._id}),
              newSkills: this.newItems,
              user: self.user._id
            };
          }
          Skills.blockMultiple({}, selected).$promise.then(function(results) {
            // no more cache
            self.blocklist.invalidateCache();
            // retrieve the current page
            self.blocklist.get();
            if (resetMain) {
              // no more cache
              self.mainPage.invalidateCache();
              // retrieve the current page
              self.mainPage.get();
              self.settings.activeSelections = {};
              self.settings.activeSelected = false;
            }
            if (self.mainPage.searching) {
              self.settings.mainClear = true;
            }
            $translate('skillsManager.success_blocked', {count: results.count}).then(function (translation) {
              Application.messaging.addMessage({type: 'success', text: translation, duration: 6});
            });
            main.cancelBlocking();
            main.cancelConfirmation();
            main.loading = false;
          }).catch(function(error) {
            main.loading = false;
            main.cancelConfirmation();
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_blocking'], duration: 6});
          });
        },
        unblockSkills: function() {
          var main = this;
          var items = Object.keys(self.settings.blockedSelections);
          this.loading = true;
          Skills.unblockMultiple({}, {skills: items}).$promise.then(function(results) {
            self.blocklist.invalidateCache();
            self.mainPage.invalidateCache();
            self.blocklist.get();
            self.mainPage.get();
            self.settings.blockedSelections = {};
            self.settings.blockedSelected = false;
            if (self.blocklist.searching) {
              self.settings.blockedClear = true;
            }
            $translate('skillsManager.success_unblocked', { length: results.length }).then(function (translation) {
              Application.messaging.addMessage({type: 'success', text: translation, duration: 6});
            });
            main.loading = false;
          }).catch(function(error) {
            main.loading = false;
            Application.messaging.addMessage({type: 'error', text: self.translation['skillsManager.error_unblocking'], duration: 6});
          });
        }
      };

      $scope.$watch('skills.blocking.term', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        if (!newVal || newVal.length < 3) {
          self.blocking.matches.splice(0);
          return;
        }

        Skills.find({
          subresource: '',
          page: 1,
          per_page: 8,
          fields: 'name',
          blocked: '$ne,true',
          name: '$regex,2,' + self.blocking.term + ',i'
        }).$promise.then(function(skills) {
          if (skills.length) {
            self.blocking.matches = skills;
            return;
          }
          self.blocking.matches.splice(0);
        });
      });

      function TabPage (config, type) {
        this.page = config.page || 1;
        this.per_page = config.per_page || 10;
        this.skills = [];
        this.loading = false;
        this.searching = false;
        this.cache = {};
        this.nextAvailable = false;
        this.previouslyCheckedNext = false;
        this.get = function() {
          var main = this;
          if (this.cache[this.page]) {
            // Use cached page
            this.update(this.cache[this.page], true);
            this.loading = false;
            if (this.skills.length === this.per_page && !this.previouslyCheckedNext) {
              this.nextAvailable = true;
            }
            this.previouslyCheckedNext = false;
            return;
          }

          this.loading = true;
          // Get current skills page
          config.query.page = this.page;
          config.query.per_page = this.per_page;
          Skills.find(config.query).$promise
          .then(function(skills) {
            main.searching = false;
            if (!skills.length && main.page > 1) {
              main.nextAvailable = false;
              main.previouslyCheckedNext = true;
              main.page--;
              main.get();
              return;
            }
            main.cache[main.page] = skills;
            main.update(skills);
            main.loading = false;
            if (main.skills.length === main.per_page && !main.previouslyCheckedNext) {
              main.nextAvailable = true;
              return;
            }
            main.nextAvailable = false;
            main.previouslyCheckedNext = false;
          });
        };
        this.update = function(skills, cached) {
          var main = this;
          this.skills = skills;
          if (type !== 'active') {
            return;
          }
          if (cached) {
            return;
          }
          // Attach the user count to each skill
          Skills.relatedUsers({}, {skills: skills.map(function(item) {return item._id})}).$promise
          .then(function(results) {
            skills.forEach(function(skill) {
              skill.userCount = results[skill._id] || 0;
            });
          });
        };
        this.next = function() {
          if (this.skills.length < this.per_page) {
            return;
          }
          this.page++;
          this.get();
        };
        this.previous = function() {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.get();
        };
        this.invalidateCache = function() {
          this.cache = {};
        };
        this.search = function(terms) {
          if (!terms || !Object.keys(terms).length) {
            this.get();
            return;
          }
          var main = this;
          this.loading = true;
          config.query.page = 1;
          config.query.per_page = 20;
          var query = JSON.parse(JSON.stringify(config.query));
          for (var key in terms) {
            query[key] = terms[key];
          }
          Skills.find(query).$promise
          .then(function(skills) {
            main.searching = true;
            main.skills = skills;
            main.loading = false;
            Skills.relatedUsers({}, {skills: skills.map(function(item) {return item._id})}).$promise
            .then(function(results) {
              skills.forEach(function(skill) {
                skill.userCount = results[skill._id] || 0;
              });
            });
          }).catch(function(error) {
            console.log('error finding single item')
          });
        };
      };

      self.blocklist = new TabPage({
        query: {
          fields: 'name,blocked,user_blocked,createdAt,blocked_date',
          blocked: 'true',
          'user_blocked-populate': 'first_name,last_name,full_name,email,image'
        }
      }, 'blocked');

      self.mainPage = new TabPage({
        query: {
          fields: 'name,user,blocked,createdAt',
          blocked: '$ne,true',
          'user-populate': 'first_name,last_name,full_name,email,image'
        }
      }, 'active');

      self.mainPage.get();

      $translate([
        'skillsManager.skill_already_in_list',
        'skillsManager.error_adding',
        'skillsManager.save_or_cancel_first',
        'skillsManager.error_updating_name',
        'skillsManager.error_accessing_user',
        'skillsManager.error_deleting_skills',
        'skillsManager.error_blocking',
        'skillsManager.error_unblocking'
      ]).then(function (translations) {
        self.translations = translations;
      });

    }],
    controllerAs: 'skills'
  }
}]);
